(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

$(".overplay-header").click(function(){
  $('body').removeClass('fixed');
  $('.overplay-header').removeClass('show');
  $('.section-vertical-mega-menu .init-toggle').removeClass('open');
  $('.section-vertical-mega-menu .vertical-mega-menu').removeClass('open');
});
  $("#sticky-header .init-toggle").click(function(){
    $(this).toggleClass('open');
    $('body').toggleClass('fixed');
    $('.overplay-header').toggleClass('show');
    $(this).closest('.section-vertical-mega-menu').find('.vertical-mega-menu').toggleClass('open');
  });

  document.querySelectorAll(".mobile-menu__title").forEach((item) => {
    item.addEventListener("click", (e) => {
      const dataId = e.target.dataset.id;

      document.querySelectorAll(".mobile-menu__title").forEach((arr_tag) => {
        arr_tag.classList.remove("active");
      });

      e.target.classList.add("active");

      document.querySelectorAll(".mb_nav_tab").forEach((content) => {
        content.classList.remove('active');
      })
      document.querySelector(`${dataId}`).classList.add("active");
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-vertical-mega-menu"]) return;
  try {
    
$("#init-toggle").click(function(){
    $(this).toggleClass('open');
    $(".vertical-mega-menu").toggleClass('open');
  });

  } catch(e) { console.error(e); }
})();
})();
